import { getFeatureConfig } from '@luna/feature-config';

import { selectMyProfileData } from './ProfileService';

const INSTITUTE_ID_LENGTH = 4;

export const getInstituteIdForCurrentUser = (): number => {
    const profile = selectMyProfileData();
    const { defaultInstituteId } = getFeatureConfig((config) => config.footer);

    return (
        profile?.companyInfo?.at_licenseHolderInstituteId ??
        profile?.instituteId ??
        defaultInstituteId
    );
};

export const getFormattedInstituteIdForCurrentUser = (): string => {
    const instituteId = getInstituteIdForCurrentUser();
    return instituteId.toString().padStart(INSTITUTE_ID_LENGTH, '0');
};
